import React from 'react';

function TabRow({ tabs, activeTab, onTabSelect, hasActiveConflicts }) {
  return (
    <div className="details-tabs-row">
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`details-tab-btn ${activeTab === tab ? 'active' : ''}`}
          onClick={() => onTabSelect(tab)}
        >
          {tab === 'Conflicts' && hasActiveConflicts && (
            <svg 
              className="tab-warning-icon" 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="#ef4444" 
              strokeWidth="2.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              style={{ marginRight: '6px', verticalAlign: 'middle', display: 'inline-block' }}
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          )}
          <span style={{ verticalAlign: 'middle' }}>{tab}</span>
        </button>
      ))}
    </div>
  );
}

export default TabRow;
